import { runtime } from '@codeArt/common';
import { wrap } from '@codeArt/utils/promise';
import _ from 'lodash';
import { getError } from './util';

function getElectron() {
    let e = window.$electron;
    if (!e) throw Error("请在桌面环境下运行");
    return e;
}


export function send(name, arg) {
    let sessionId = _.uniqueId("ipcSessionId_");
    let winId = runtime.electron.winId;
    let wrapper = { arg, sessionId, winId };
    return wrap((resolve, reject) => {
        let { ipcRenderer } = getElectron();
        ipcRenderer.once(`reply-${name}-${sessionId}`, (event, arg) => { //先监听回调
            let e = arg?.error;
            if (e) {
                reject(getError(e));
                return;
            }
            resolve(arg);
        });
        ipcRenderer.send(name, wrapper);  //再发送
    });
}


const { accept, unaccept, parseEvent } = (function () {

    // const eventHandles = {};

    // function createEventHandle(name,handle){

    //     let wrapper = (event,arg)=>{  
    //         handle(arg);
    //     };

    //     eventHandles[name] = wrapper;
    //     return wrapper;
    // }

    // function getAndRmoveEventHandle(name){
    //     let wrapper = eventHandles[name];
    //     delete eventHandles[name];
    //     return wrapper;
    // }

    function EventScheduler() {

        const _handlers = {};

        this.addHandle = (dot, handle) => {
            _handlers[dot] = handle;
        }

        this.removeHandle = (dot) => {
            delete _handlers[dot];
            for (let key in _handlers) {
                return false; //还有数据
            }
            return true;//没有数据，返回真
        }

        this.exec = (event, arg) => {//实际传的handle被包装了，框架要求2个参数，这里我们实际只用1个参数
            for (let key in _handlers) {
                _handlers[key](arg);
            }
        }
    }

    const _schedulers = {};
    EventScheduler.get = (eventName) => {
        let sheduler = _schedulers[eventName];
        if (sheduler) return { sheduler, exist: true };  //已存在的调度器
        _schedulers[eventName] = sheduler = new EventScheduler();
        return { sheduler, exist: false };  //新调度器
    }

    EventScheduler.remove = (eventName) => {
        delete _schedulers[eventName];
    }

    function accept(eventName, dot, handle) {  //接入响应事件

        const { sheduler, exist } = EventScheduler.get(eventName);
        sheduler.addHandle(dot, handle);
        if (!exist) {
            //如果是新调度器，那么要接入事件
            let { ipcRenderer } = getElectron();
            ipcRenderer.on(`accept-${eventName}`, sheduler.exec);
            return true;//提示外部，是新的接入
        }
    }

    function unaccept(eventName, dot) {  //取消接入

        const { sheduler } = EventScheduler.get(eventName);
        if (sheduler.removeHandle(dot)) {
            let { ipcRenderer } = getElectron();
            ipcRenderer.removeListener(`accept-${eventName}`, sheduler.exec);
            EventScheduler.remove(eventName);
            return true;//返回true，表示要断开绑定了
        }
    }

    function parseEvent(name) {  //传递的事件有可能带.，要提取实际事件名称
        let pos = name.indexOf(".");
        if (pos > -1) return { eventName: name.substr(0, pos), dot: name.substr(pos + 1) };
        return { eventName: name, dot: "" };
    }

    return { accept, unaccept, parseEvent };

})();


export function on(name, handle) {
    return wrap((resolve, reject) => {
        let { eventName, dot } = parseEvent(name);
        if (accept(eventName, dot, handle))
            send(eventName, { on: true }).then(resolve).catch(reject);  //是新的接入，那么要发送真实消息给主进程
        else
            resolve();
    });
}

export function off(name) {
    return wrap((resolve, reject) => {
        let { eventName, dot } = parseEvent(name);
        if (unaccept(eventName, dot))
            send(eventName, { off: true }).then(resolve).catch(reject);
        else
            resolve();
    });
}

export * from './service';